const SESSION_KEY = "dispatch-management-auth-token";
const REFRESH_KEY = "dispatch-management-auth-refresh";
const EXPIRES_KEY = "dispatch-management-auth-expires-at";

export const getSessionToken = () => window.localStorage.getItem(SESSION_KEY);
export const getRefreshToken = () => window.localStorage.getItem(REFRESH_KEY);
export const getSessionExpiresAt = () => Number(window.localStorage.getItem(EXPIRES_KEY) || 0);

export const saveSession = (session) => {
  const payload = typeof session === "string" ? { access_token: session } : session || {};
  if (payload.access_token) {
    window.localStorage.setItem(SESSION_KEY, payload.access_token);
  }
  if (payload.refresh_token) {
    window.localStorage.setItem(REFRESH_KEY, payload.refresh_token);
  }
  if (payload.expires_in) {
    window.localStorage.setItem(EXPIRES_KEY, String(Date.now() + Number(payload.expires_in) * 1000));
  }
};

export const clearSession = () => {
  window.localStorage.removeItem(SESSION_KEY);
  window.localStorage.removeItem(REFRESH_KEY);
  window.localStorage.removeItem(EXPIRES_KEY);
};
